var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSuccessful = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 25.25A9.25 9.25 0 0 1 6.75 16h-1.5c0 5.937 4.813 10.75 10.75 10.75zM25.25 16A9.25 9.25 0 0 1 16 25.25v1.5c5.937 0 10.75-4.813 10.75-10.75zM16 6.75A9.25 9.25 0 0 1 25.25 16h1.5c0-5.937-4.813-10.75-10.75-10.75zm0-1.5C10.063 5.25 5.25 10.063 5.25 16h1.5A9.25 9.25 0 0 1 16 6.75zm-3.842 10.2a.75.75 0 1 0-1.066 1.055zm2.954 4.05-.533.528a.75.75 0 0 0 1.102-.04zm5.832-5.636a.75.75 0 0 0-1.138-.978zm-9.852 2.64 3.487 3.524 1.066-1.056-3.487-3.523-1.066 1.056zm4.59 3.485 5.262-6.125-1.138-.978-5.263 6.125 1.138.978z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSuccessful);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };